export default class CardBody extends React.Component {
  render() {
    const {className, ...restProps} = this.props

    return (
      <div className={classNames("components-card-body", className)} {...restProps} />
    )
  }
}
